import {useLongTermDisabilityCoveragePopulator} from '../populator/useLongTermDisabilityCoveragePopulator';
import {useDispatch} from 'react-redux';

export const useLongTermDisabilityCoverageDispatcher = () => {
    const populateLongTermDisabilityCoverage = useLongTermDisabilityCoveragePopulator();
    const dispatch = useDispatch();

    const dispatchCoverage = (selectedRate) => {
        const data = populateLongTermDisabilityCoverage(selectedRate);
        dispatch({
            type: 'UPDATE_MEMBER_ELECTION',
            data: data
        });
    };

    return (selectedRate) => dispatchCoverage(selectedRate);
};